import { render, staticRenderFns } from "./CsDashboard.vue?vue&type=template&id=05b05864&"
import script from "./CsDashboard.vue?vue&type=script&lang=js&"
export * from "./CsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports